import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type LocationScope = 'single' | 'all';

interface LocationSettings {
  hide_default_payment_types?: boolean;
  /** Whether new products should have inventory tracking enabled by default (defaults to true when undefined) */
  default_track_inventory?: boolean;
}

interface Location {
  id: string;
  name: string;
  organization_id: string;
  phone?: string | null;
  email?: string | null;
  address?: { line1?: string; city?: string; parish?: string } | null;
  is_active?: boolean;
  settings?: LocationSettings | null;
}

interface LocationState {
  currentLocation: Location | null;
  locations: Location[];
  /** UI scope for views that support aggregating across locations */
  locationScope: LocationScope;
  setCurrentLocation: (location: Location | null) => void;
  setLocations: (locations: Location[]) => void;
  setLocationScope: (scope: LocationScope) => void;
}

export const useLocationStore = create<LocationState>()(
  persist(
    (set) => ({
      currentLocation: null,
      locations: [],
      locationScope: 'single',
      setCurrentLocation: (location) => set({ currentLocation: location }),
      setLocations: (locations) => set({ locations }),
      setLocationScope: (scope) => set({ locationScope: scope }),
    }),
    {
      name: 'blazepos-location',
      partialize: (state) => ({
        currentLocation: state.currentLocation,
        locationScope: state.locationScope,
      }),
    }
  )
);





